export default __webpack_public_path__ + "static/media/longchamp22.426daaf2.jpg";